// Keyboard + mouse device. Writes into shared device state read by InputManager.

export class KeyboardMouse {
  steer = 0;
  camNudge = { x: 0, y: 0 };
  jumpEdge = false;
  pauseEdge = false;
  active = false;

  private left = false;
  private right = false;

  constructor() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('mousemove', this.onMouseMove);
  }

  private onKeyDown = (e: KeyboardEvent) => {
    switch (e.code) {
      case 'KeyA':
      case 'ArrowLeft':
        this.left = true;
        this.active = true;
        break;
      case 'KeyD':
      case 'ArrowRight':
        this.right = true;
        this.active = true;
        break;
      case 'Space':
        if (!e.repeat) this.jumpEdge = true;
        this.active = true;
        e.preventDefault();
        break;
      case 'Escape':
        this.pauseEdge = true;
        break;
    }
    this.updateSteer();
  };

  private onKeyUp = (e: KeyboardEvent) => {
    switch (e.code) {
      case 'KeyA':
      case 'ArrowLeft':
        this.left = false;
        break;
      case 'KeyD':
      case 'ArrowRight':
        this.right = false;
        break;
    }
    this.updateSteer();
  };

  private onMouseMove = (e: MouseEvent) => {
    // Only nudge while a button is held, so casual mouse movement is ignored.
    if (e.buttons & 1) {
      this.camNudge.x += e.movementX * 0.01;
      this.camNudge.y += e.movementY * 0.01;
      this.active = true;
    }
  };

  private updateSteer() {
    this.steer = (this.right ? 1 : 0) - (this.left ? 1 : 0);
    // Considered active while a steer key is held (so steering persists).
    this.active = this.left || this.right;
  }

  dispose() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('mousemove', this.onMouseMove);
  }
}
